import { LOCATIONS_ACTIONS, initialLocationsState } from './locations.types'

/**
 * @param {import('./locations.types').LocationsSlice} state
 * @param {import('./locations.types').LocationsAction} action
 * @returns {import('./locations.types').LocationsSlice}
 */
export function locationsReducer(state = initialLocationsState, { type, payload }) {
  switch (type) {
    case LOCATIONS_ACTIONS.SET_LOCATIONS_STATUS:
      return {
        ...state,
        status: payload
      }

    case LOCATIONS_ACTIONS.SET_LOCATIONS_ERRORS:
      return {
        ...state,
        errors: [payload, ...state.errors]
      }

    case LOCATIONS_ACTIONS.SET_LOCATION_OPTIONS:
      return {
        ...state,
        options: payload
      }

    default:
      return state
  }
}
